__turbopack_context__.v({
  "actionButton": "DonnyBookingEmbed-module__nPXgoa__actionButton",
  "calEmbed": "DonnyBookingEmbed-module__nPXgoa__calEmbed",
  "donnyBookingEmbed": "DonnyBookingEmbed-module__nPXgoa__donnyBookingEmbed",
  "externalLink": "DonnyBookingEmbed-module__nPXgoa__externalLink",
  "fallback": "DonnyBookingEmbed-module__nPXgoa__fallback",
  "fallbackActions": "DonnyBookingEmbed-module__nPXgoa__fallbackActions",
  "frame": "DonnyBookingEmbed-module__nPXgoa__frame",
  "frameWrap": "DonnyBookingEmbed-module__nPXgoa__frameWrap",
  "header": "DonnyBookingEmbed-module__nPXgoa__header",
  "loadingProgress": "DonnyBookingEmbed-module__nPXgoa__loadingProgress",
  "subtitle": "DonnyBookingEmbed-module__nPXgoa__subtitle",
  "title": "DonnyBookingEmbed-module__nPXgoa__title",
});
